import { useTranslation } from "react-i18next"
import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import useGetComments from "hooks/useGetComments"
import BottomSheet from "components/atoms/BottomSheet"
import AddCommentInput from "components/organisms/WishItemBottomSection/AddCommentInput"
import CommentsList from "components/organisms/WishItemBottomSection/CommentsList"

type ExpandedSectionProps = {
  show: boolean;
  id: number;
  onOpen: () => void;
  onClose: (selectedLists: number[]) => void;
}

export default function CommentsBottomSheet(props: ExpandedSectionProps) {
  const { show, id, onOpen, onClose } = props

  const { t } = useTranslation()

  const { comments, isFetching } = useGetComments(id, show)

  return (
    <BottomSheet
      id="comments-bottom-sheet"
      title={""}
      show={show}
      openBottomSheet={onOpen}
      closeBottomSheet={onClose}
    >
      <Container>
        <TitleWrapper>
          <Title>{t("items.comments")}</Title>
          <Count>{comments?.length} {t("items.comment")}</Count>
        </TitleWrapper>
        <CommentsList
          comments={comments}
          count={comments?.length}
          isFetching={isFetching}
        />
        <AddCommentInput id={id}/>
      </Container>
    </BottomSheet>
  )
}

const Container = styled(Stack)(({ theme }) => ({
  width: "100%",
  height: "65vh",
  justifyContent: "space-between",

  "& .MuiTextField-root": {
    marginBottom: "0 !important",
    padding: "0 4px"
  }
}))

const TitleWrapper = styled(Stack)(({ theme }) => ({
  width: "1005",
  flexDirection: "row",
  justifyContent: "space-between",
  marginBottom: "10px",
  padding: "0 4px"
}))

const Title = styled(Typography)(({ theme }) => ({
  fontSize: "1.2rem",
  fontWeight: 500,
  color: theme.palette.gray["15"]
}))

const Count = styled(Typography)(({ theme }) => ({
  fontSize: "1.2rem",
  fontWeight: 400,
  color: theme.palette.gray["12"],
  fontFamily: "VazirmatnFD, serif !important"
}))
